import React from "react";
import {
  DetailsList, DetailsListLayoutMode,
  IColumn,
  SelectionMode,
  TooltipOverflowMode,
} from "@fluentui/react";
import {
  _legalColumns,
  _naturalColumns,
} from "../SearchForPOI/SearchForPOIUtils";
import {TooltipHost} from "@fluentui/react/lib/Tooltip";

interface PersonOfInterestDetailsListProps {
  type: string;
  items: any[];
  columns: IColumn[];
  userInfo: UserInfo;
  renderItemColumn: any;
  handleItemClick: any;
}
interface UserInfo {
  roles: string[];
}
function PersonOfInterestDetailsList(props: PersonOfInterestDetailsListProps) {

  // Define columns based on the selected 'type'
  const columnsToUse: IColumn[] = getColumnsByType(props.type);

  return (
      <DetailsList
          layoutMode={1}
          columns={columnsToUse.map((column) => ({
            ...column,
            onRenderHeader: () => (
            <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={column.name}>{column.name}</TooltipHost>
  ),
}))}
items={props.items}
selectionMode={SelectionMode.none}
selectionPreservedOnEmptyClick={true}
onRenderItemColumn={props.renderItemColumn}
/>
);
}
// Define your columns separately
const getColumnsByType = (type: string): IColumn[] => {
  switch (type) {
    case "1":
      return _naturalColumns;
    case "2":
      return _legalColumns;
    default:
      return [];
  }
};

export default PersonOfInterestDetailsList;